import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { updateStatus } from '../../async/ice/iceasync'
import { getBillOfMaterialDetails } from 'src/services/shouldCostAIBased.services'

const initialState = {
  summaryTableLoader: false,
  summaryTableError: '',
  updateStatusLoader: false,
  updateStatusData: [],
  summaryTable_state: [],
}

export const summaryTableSlice = createSlice({
  name: 'summaryTable',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getBillOfMaterialDetails.pending, updateStatus.pending), (state) => {
      state.summaryTableLoader = true
    })
    builder.addMatcher(
      isAnyOf(getBillOfMaterialDetails.fulfilled, updateStatus.fulfilled),
      (state, action) => {
        state.summaryTableLoader = false
        state.summaryTable_state = action.payload
        state.summaryTableError = ''
      },
    )

    builder.addMatcher(
      isAnyOf(getBillOfMaterialDetails.rejected, updateStatus.rejected),
      (state, action) => {
        state.summaryTableLoader = false
        state.summaryTableError = action.payload
      },
    )
  },
  reducers: {
    emptysummaryTableSlice: (state) => {
      state.summaryTableLoader = false
      state.summaryTableError = ''
      state.summaryTable_state = []
    },
  },
})

export const { emptysummaryTableSlice } = summaryTableSlice.actions

export default summaryTableSlice.reducer
